import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-error",
  "use": "app-icon-error-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-error\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8z\" fill=\"#F45C5E\" /><path d=\"M9 12.6H7v-2h2v2zm-.34-3.5H7.283l-.384-6h2.2l-.44 6z\" stroke=\"#FFF\" stroke-width=\".2\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol